import {Reducer} from "react";
import {CreateStoreServiceActions, CreateStoreServiceState} from "./types";

export const initialCreateStoreServiceState: CreateStoreServiceState = {
  currentCreateStoreServiceStep: "basicForm",
  formData: {
    bookingQuestions: [],
    description: "",
    hideFromProfile: false,
    isUrlRedirect: false,
    redirectAfterPurchase: "none",
    telegramGroupId: undefined,
    name: "",
    requestCustomerPhoneNumber: false,
    limitUnitsPerTransaction: false,
    purchaseLimit: undefined,
    url_redirect: undefined,
    priceType: "paid",
    currencies: [],
    deliveryTimeFrameUnit: "days",
    deliveryTimeFrameValue: 1,
  },
  apiResponseData: null,
};

export function createInitialCreateStoreServiceReducerStateFromApi(args: {
  bankConnected: boolean;
  defaultCurrency: string; // e.g. currencyContextState.formCurrencies[0]
}): CreateStoreServiceState {
  const priceType = args.bankConnected ? "paid" : "free";
  return {
    currentCreateStoreServiceStep: "basicForm",
    formData: {
      bookingQuestions: [],
      description: "",
      hideFromProfile: false,
      isUrlRedirect: false,
      redirectAfterPurchase: "none",
      telegramGroupId: undefined,
      name: "",
      requestCustomerPhoneNumber: false,
      limitUnitsPerTransaction: false,
      purchaseLimit: undefined,
      url_redirect: undefined,
      deliveryTimeFrameUnit: "days",
      deliveryTimeFrameValue: 1,
      priceType, // seeded once
      currencies: [
        {
          callPrice: 100,
          callPriceCurrency: args.defaultCurrency,
        },
      ],
    },
    apiResponseData: null,
  };
}

export const createStoreServiceReducer: Reducer<
  CreateStoreServiceState,
  CreateStoreServiceActions
> = (
  state: CreateStoreServiceState = initialCreateStoreServiceState,
  action: CreateStoreServiceActions
) => {
  if (action.type === "update-create-service-form-step") {
    const yo = {...state, currentCreateStoreServiceStep: action.payload};
    return yo;
  }
  if (action.type === "save-create-store-service-form-values") {
    const yo = {
      ...state,
      formData: {
        ...state.formData,
        ...action.payload,
      },
    };
    return yo;
  }
  if (action.type === "save-create-store-service-api-response") {
    const yo = {
      ...state,
      apiResponseData: action.payload.apiResponseData,
    };
    return yo;
  }

  if (action.type === "reset-state") {
    const yo = {...initialCreateStoreServiceState};
    return yo;
  }

  return state;
};
